import { memo, useEffect, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';

import AccountSlider from 'components/AccountSlider';
import useTopPanel from 'hooks/useTopPanel';
import AccountTable from 'components/ui/tables/AccountTable';
import InboxModal from './InboxModal';
import AddEditModal from './AddEditModal';
import ConversionModal from './ConversionModal';
import { Link, useLocation } from 'react-router-dom';
import AccountFilterDrawer from '../../../components/dashboard/AccountFilterDrawer';

const Account = () => {
  const { setComponent } = useTopPanel();
  const [accountId, setAccountId] = useState('');
  const [accountsError, setAccountsError] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openConversionModal, setOpenConversionModal] = useState(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const from = searchParams.get('from');
  const till = searchParams.get('till');

  const queryString = from && till ? `?from=${from}&till=${till}` : '';

  useEffect(() => {
    setComponent(<div className='component-title'>Kassalar</div>);
  }, []);

  return (
    <div className='component-list-wrapper'>
      <AccountSlider
        accountId={accountId}
        setAccountId={setAccountId}
        setAccountsError={setAccountsError}
        emitRefetch={{ refetch, setRefetch }}
      />
      <div className='component-list-header mb-2'>
        <div className='header-actions-container pt-2 pb-2 flex flex-row items-center'>
          <div className='header-actions filter-box flex items-center'>
            <Button
              variant='base'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
              onClick={() => !accountsError && setOpenFilter((prev) => !prev)}
              disabled={accountsError}
            >
              Filter
            </Button>
          </div>
          <div className='grow'>
            {/* <SearchInputNavbar inputKey='name' fullWidth /> */}
            <div className='my-2 bg-white h-[45px] rounded-[10px] border' />
          </div>
          <div className='header-actions action-buttons-box flex items-center justify-center ml-4'>
            <Button
              variant='base'
              onClick={() => {
                !accountsError && setRefetch(true);
              }}
              disable={`${refetch}`}
              disabled={accountsError}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Link
              to={`${process.env.REACT_APP_BACKEND_URL}/excel/accounthistory/${accountId}${queryString}`}
              className='no-underline !mx-2'
            >
              <Button variant='base' color='success'>
                <i className='bi bi-download' />
              </Button>
            </Link>
            <Button
              variant='base'
              className='!ml-2'
              onClick={() => !accountsError && setOpenAddModal(true)}
              disabled={accountsError}
            >
              <i className='bi bi-plus-circle' />
            </Button>
            <Button
              variant='base'
              className='!ml-2'
              onClick={() => !accountsError && setOpenConversionModal(true)}
              disabled={accountsError}
            >
              <i className='bi bi-currency-exchange text-xl' />
            </Button>
            <Button
              variant='base'
              className='!ml-2'
              onClick={() => !accountsError && setOpenModal(true)}
              disabled={accountsError}
            >
              <i className='bi bi-box-arrow-in-down' />
            </Button>
            <Button
              variant='base'
              className='!ml-2'
              onClick={() => !accountsError && setOpen(true)}
              disabled={accountsError}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>
      <div className='component-table-wrapper h-[calc(100vh-290px)] flex-auto'>
        {accountId ? (
          <AccountTable
            emitRefetch={{ refetch, setRefetch }}
            emitTableColumns={{ open, setOpen }}
            dataPath={`admin/accounts/history/${accountId}`}
          />
        ) : !accountsError ? (
          <div className='circular-progress-box'>
            <CircularProgress size={30} />
          </div>
        ) : (
          <div className='my-6'>
            <span className='no-data-found-wrapper'>
              <i className='bi bi-exclamation-octagon text-xl mr-1 leading-3' />{' '}
              Ma'lumot topilmadi!
            </span>
          </div>
        )}
      </div>
      {openModal && (
        <InboxModal
          open={openModal}
          setOpen={setOpenModal}
          itemId={accountId}
          setRefetch={setRefetch}
        />
      )}
      {openAddModal && (
        <AddEditModal
          open={openAddModal}
          setOpen={setOpenAddModal}
          // itemId={accountId}
          setRefetch={setRefetch}
        />
      )}
      {openConversionModal && (
        <ConversionModal
          open={openConversionModal}
          setOpen={setOpenConversionModal}
          itemId={accountId}
          setRefetch={setRefetch}
        />
      )}
      <AccountFilterDrawer open={openFilter} setOpen={setOpenFilter} />
    </div>
  );
};

export default memo(Account);
